var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sign-input"},[_c('label',[_vm._v("Подпись")]),_c('div',{staticClass:"sign-input__vue-signature-pad"},[_c('VueSignaturePad',{ref:"signaturePad",attrs:{"options":_vm.options}})],1),_c('button',{staticClass:"sign-input__clear",attrs:{"type":"button","title":"Стереть"},on:{"click":_vm.clear}},[_vm._v(" Стереть ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }